import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/services/api.service';


@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {

  submitted: boolean = false;

  changePasswordSuccess: boolean;

  changePasswordError: string;

  oldPassword: string;

  newPassword: string;

  newPasswordRetype: string;

  settings: any;

  pwdPattern: string;

  pwdErrorMsg: string;

  pwdMinLength: number;

  fieldTextType: boolean = false;

  newPasswordTextType: boolean = false;

  confirmPasswordTextType: boolean = false;

  get notificationsEnabled() {
    if (!this.settings) return true;
    return !this.settings.DisableNotifications;
  }
  set notificationsEnabled(value) {
    console.log(this.settings);
    this.settings.DisableNotifications = !value;
  }

  constructor(
    private api: ApiService
  ) {
    api.pageTitle = 'Einstellungen';
  }

  ngOnInit() {
    this.pwdMinLength = 8;
    this.pwdPattern = "(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{8,}";
    this.pwdErrorMsg = "Das Passwort muss mindestens 8 Zeichen lang sein und 1 Großbuchstaben, 1 Kleinbuchstaben und 1 Sonderzeichen enthalten";
  }

  toggleFieldTextType(controlName: string) {
    if (controlName == 'CP') {
      this.fieldTextType = !this.fieldTextType;
    }
    if (controlName == 'NP') {
      this.newPasswordTextType = !this.newPasswordTextType;
    }
    if (controlName == 'COP') {
      this.confirmPasswordTextType = !this.confirmPasswordTextType;
    }
  }

  changePassword() {
    if (this.newPassword != this.newPasswordRetype) {
      this.changePasswordError = "Die Eingaben für das neue Passwort stimmen nicht überein";
      return;
    }

    if (this.newPassword == this.oldPassword) {
      this.changePasswordError = "Neues und altes Passwort dürfen nicht identisch sein";
      return;
    }

    var args = {
      Password: this.oldPassword,
      NewPassword: this.newPassword
    };
    this.submitted = true;
    this.changePasswordError = "";
    this.changePasswordSuccess = false;
    this.api.changePassword(this.oldPassword, this.newPassword).subscribe(d => {
      if (d.Succeeded) {
        this.changePasswordSuccess = true;
        this.newPassword = "";
        this.newPasswordRetype = "";
        this.oldPassword = "";
        this.submitted = false;
      }
      else {
        this.changePasswordError = d.Error
        this.submitted = false;
      }

    }, error => {
      if (error.message) {
        this.changePasswordError = error.message;
      }
      else {
        this.changePasswordError = "Ein Fehler ist aufgetreten";
      }
    })
  }

  save() {
    this.api.put('account/settings', this.settings).subscribe(d => { });
  }

}
